import React from "react";
import { FileTextIcon, LanguagesIcon, LayersIcon, ListChecksIcon } from "lucide-react";
const items = [{
  icon: LanguagesIcon,
  title: "Explicaciones en español",
  text: "Entendés la teoría sin traducirla."
}, {
  icon: LayersIcon,
  title: "Organizado por tomos",
  text: "Cada etapa tiene su lugar."
}, {
  icon: FileTextIcon,
  title: "Formato PDF",
  text: "Leé en pantalla o imprimí."
}, {
  icon: ListChecksIcon,
  title: "Tres opciones",
  text: "Base, Pro o Completo."
}];
export function TrustStrip() {
  return <section aria-label="Características del material" className="border-y border-pizarra/10 bg-crema/70" data-id="element-252" data-mp="1pn8q3o2smjqq">
      <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 px-4 py-8 md:grid-cols-4 md:divide-x md:divide-pizarra/10 md:px-6" data-id="element-253" data-mp="1ku64c249cel3">
        {items.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex flex-col items-center gap-2 px-3 text-center" data-id="element-254" data-mp="2dctjz20hj1es">
            <Icon className="h-5 w-5 text-terracota-deep" aria-hidden="true" data-id="element-255" data-mp="28ktd0plzz88p" />
            <p className="font-semibold text-pizarra-deep" data-id="element-256" data-mp="32v444qyeks2v">{title}</p>
            <p className="text-sm text-pizarra-soft" data-id="element-257" data-mp="32wxa0416z89t">{text}</p>
          </li>)}
      </ul>
    </section>;
}